import Swiper from "swiper/bundle";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Scrollbar from "smooth-scrollbar";
import { isMobile, isTablet, isDesktop } from "../components/exportFunc";

export default () => {
  const sliderWrapper = document.querySelector("[data-home-hero-slider]");
  const preloader = document.querySelector("[preloader]");
  const preloaderAfter = document.querySelector("[preloader-after]");
  const header = document.querySelector("[header]");
  const videoWrapper = document.querySelector("[home-video]");

  const DURATION = 1;
  gsap.registerPlugin(ScrollTrigger);
  let scrollbar = Scrollbar.get(document.querySelector(".scroll-container"));
  document.querySelector(".scroll-container").style.opacity = 1;
  scrollbar.contentEl
    .querySelector(".scroll-inner-content")
    .classList.add("scroll-content--stoped");
  if (sliderWrapper) {
    let slider = new Swiper(sliderWrapper, {
      slidesPerView: "auto",
      loop: true,
      speed: 1500,
      autoplay: {
        delay: 10000,
      },
    });
  }

  //#region preloader

  if (isMobile()) {
    gsap.to(preloaderAfter, {
      duration: 1,
      onComplete: () => {
        gsap.to(header, {
          opacity: 1,
          zIndex: 1000,
          delay: 3,
          duration: 1,
        });
        scrollbar.contentEl
          .querySelector(".scroll-inner-content")
          .classList.remove("scroll-content--stoped");
      },
    });
  } else {
    window.scrollTo(0, 0);

    gsap.to(preloader, {
      opacity: 0,
      duration: 3,
      delay: 3,
      ease: "power1.inOut",
      onComplete: () => {
        preloader.style.zIndex = "-1";
      },
    });
    gsap.to(preloaderAfter, {
      opacity: 1,
      duration: 2.5,
      delay: 4,
      ease: "power1.out",
      onComplete: () => {
        gsap.to(header, {
          opacity: 1,
          zIndex: 1000,
          duration: 0.5,
        });
        scrollbar.contentEl
          .querySelector(".scroll-inner-content")
          .classList.remove("scroll-content--stoped");
      },
    });
  }

  //#endregion

  // #region VIDEO BOX
  videoWrapper ? videoWrapperHandle() : false;

  function videoWrapperHandle() {
    const img = videoWrapper.querySelector("[home-video-img]");
    const quote = videoWrapper.querySelector("[home-video-quote]");
    if (isMobile() || isTablet()) {
      return;
    }

    let opacity = 0;

    const timeLine = gsap.timeline({
      scrollTrigger: {
        trigger: videoWrapper,
        start: "top center",
        scrub: 2,
        end: "+=50%",
        once: true,
      },

      onUpdate: () => {
        opacity += 0.01;
        gsap.to(quote, { opacity, duration: 1 });
      },

      onComplete: () => {
        opacity = 1;
        gsap.to(quote, { opacity, duration: 1.2 });
      },
    });
    timeLine.to(img, { scale: 1 });
  }
  //#endregion

  //#region BODY/SOUL
  const soulWrapper = document.querySelector("[home-soul]");

  soulWrapper && isDesktop() ? soulHandle() : false;

  function soulHandle() {
    const sideBoxes = soulWrapper.querySelectorAll(".side-box");

    sideBoxes.forEach((el) => {
      const front = el.querySelector(".side-box__front");
      const back = el.querySelector(".side-box__back");
      const img = back.querySelector(".img-box");
      const title = back.querySelector("h2");
      const info = back.querySelector(".info");
      const circle = front.querySelector("circle");
      el.addEventListener("mouseenter", () => {
        gsap.to(circle, {
          opacity: 0,
          duration: 0.5,
        });
        gsap.to(front, {
          duration: 0.5,
          opacity: 0,
        });
        gsap.fromTo(
          img,
          {
            x: -50,
            opacity: 0,
          },
          {
            x: 0,
            opacity: 1,
            duration: 1,
          }
        );
        gsap.fromTo(
          title,
          {
            y: 30,
            opacity: 0,
          },
          {
            y: 0,
            opacity: 1,
            duration: 1,
          }
        );
        gsap.fromTo(
          info,
          {
            y: 30,
            opacity: 0,
          },
          {
            y: 0,
            opacity: 1,
            duration: 1,
            delay: 0.2,
          }
        );
      });
      el.addEventListener("mouseleave", () => {
        gsap.to(img, {
          x: -50,
          opacity: 0,
          duration: 0,
        });
        gsap.to(title, {
          y: 30,
          opacity: 0,
          duration: 0,
        });
        gsap.to(info, {
          y: 30,
          opacity: 0,
          duration: 0,
        });
        gsap.to(front, {
          duration: 0.5,
          opacity: 1,
        });
      });
    });
  }
  //#endregion
};
